<template>
  <b-form class="mb-5" v-if="!loading">
    <b-row>
      <b-col cols="12" md="6">
        <b-form-group
          v-if="!loading"
          label-for="name"
          :label="this.$t('Location Name')"
          :state="$validateState($v.form.name)"
        >
          <b-form-input
            data-test-id="sites-site-details-site-name"
            id="name"
            v-model="form.name"
            @blur="setValidationInput('name', $event.target.value)"
            :state="$validateState($v.form.name)"
            :placeholder="this.$t('Enter site name')"
          />
          <template #invalid-feedback>
            <p v-if="!$v.form.name.required">
              {{ $t("This is a required field.") }}
            </p>
          </template>
        </b-form-group>

        <b-form-group
          id="site-id"
          :label="this.$t('Location ID')"
          label-for="site-id"
        >
          <b-form-input
            id="site-id"
            data-test-id="sites-site-details-site-id"
            v-model="selectedLocation.id"
            disabled
          ></b-form-input>
        </b-form-group>

        <b-form-group id="type" :label="this.$t('Type')" label-for="type">
          <b-form-input
            id="type"
            data-test-id="sites-site-details-type"
            v-model="locationType"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          v-if="!loading"
          label-for="ip"
          :label="this.$t('IP Address')"
          :state="$validateState($v.form.ip)"
        >
          <b-form-input
            data-test-id="sites-site-details-site-ip"
            id="ip"
            v-model="form.ip"
            @blur="setValidationInput('ip', $event.target.value)"
            :state="$validateState($v.form.ip)"
            :placeholder="this.$t('Enter site IP')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.ip.required">
              {{ $t("This is a required field.") }}
            </p>
          </template>
        </b-form-group>

        <b-form-group
          v-if="!loading"
          label-for="description"
          :label="this.$t('Description')"
          :state="$validateState($v.form.description)"
        >
          <b-form-textarea
            data-test-id="sites-site-details-site-description"
            id="description"
            v-model="form.description"
            @blur="setValidationInput('description', $event.target.value)"
            :state="$validateState($v.form.description)"
            :placeholder="this.$t('e.g. 1055 West 7th Street, 33rd')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.description.required">
              {{ $t("This is a required field.") }}
            </p>
          </template>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="12">
        <b-form-group id="policy" :label="this.$t('Policy')" label-for="policy">
          <t-radio-group
            v-model="form.policy"
            :loading="fetching"
            :items="policyRadio"
            :dropdownOptions="policyOptions"
            :selectedItem="form.policyid"
            :selectedItemLabel="form.policyName"
            @change="$v.$touch()"
            @changeDropDown="onDropDownChange"
            @scrollDropDown="scrollDropDown"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <t-save-button
      data-test-id="sites-site-details-save"
      :form-model="$v.form"
      :fetching="fetching"
      @submit="onSubmit"
    />
  </b-form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TSiteStaticip",
  props: {
    policyOptions: {
      type: Array,
      required: true,
    },
    policyRadio: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    locationType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      fetching: false,
      form: {
        policy: "None",
        policyid: null,
        policyName: "",
        name: null,
        ip: null,
        description: null,
      },
    };
  },
  validations: {
    form: {
      policyid: {},
      name: {
        required,
      },
      ip: {
        required,
      },
      description: {},
    },
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser"]),
    ...mapGetters("locations", ["selectedLocation"]),
  },
  methods: {
    ...mapActions("toast", ["displayToast"]),
    ...mapActions("locations", ["updateLocation"]),
    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },
    onDropDownChange(item) {
      this.form.policyid = item;
      this.$v.$touch();
    },
    scrollDropDown(item) {
      this.$emit("scroll", item);
    },
    async onSubmit() {
      this.fetching = true;
      try {
        await this.updateLocation({
          id: this.selectedUser.id,
          type: this.selectedLocation.type,
          locationId: this.selectedLocation.id,
          body: {
            ...this.form,
            policyid:
              this.form.policyid === null || this.form.policy === "None"
                ? ""
                : this.form.policyid,
          },
        });
        this.displayToast({
          title: this.$t("Success"),
          message: "Updated",
          duration: 2000,
          variant: "success",
        });
      } finally {
        this.fetching = false;
        this.$v.form.$reset();
      }
    },
  },
  watch: {
    selectedLocation: {
      handler() {
        this.form = {
          name: this.selectedLocation.name,
          ip: this.selectedLocation.addresses[0].ip,
          policyid: this.selectedLocation.policy_id || null,
          policyName: this.selectedLocation.policy_name || null,
          description: this.selectedLocation.addresses[0].description || null,
        };
        if (this.form.policyid === null) {
          this.form.policy = "None";
        } else {
          this.form.policy = "Policy";
        }
      },
      immediate: true,
    },
  },
};
</script>
